// import React from "react";
// import {
//   Nav,
//   Form,
//   FormControl,
//   Badge,
//   Offcanvas,
//   Navbar,
// } from "react-bootstrap";
// import { Search } from "react-bootstrap-icons";
// import { TiThLargeOutline } from "react-icons/ti";
// import { IoMdBook, IoIosNotificationsOutline } from "react-icons/io";
// import { TfiMenuAlt } from "react-icons/tfi";
// import { BsBuildings } from "react-icons/bs";
// import { FaGlasses, FaRegUserCircle } from "react-icons/fa";
// import { RiPieChartLine } from "react-icons/ri";
// import { useLocation } from "react-router-dom";

// const Sidebar = ({ show, onClose }) => {
//   const location = useLocation();
//   const sidebarContent = (
//     <>
//       <Nav className="flex-column">
//         <Nav.Link
//           href="/"
//           className={`mb-3 ${
//             location.pathname === "/"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <TiThLargeOutline
//             className="me-2"
//             color={location.pathname === "/" ? "#136ABE" : "rgba(0,0,0,0.7)"}
//             size={20}
//           />
//           <span>Overview</span>
//         </Nav.Link>
//         <Nav.Link
//           href="/courses"
//           className={`mb-3 ${
//             location.pathname.startsWith("/courses") ||
//             location.pathname === "/add-course" ||
//             location.pathname === "/add-leason" ||
//             location.pathname === "/add-module" ||
//             location.pathname === "/add-prerecord" ||
//             location.pathname === "/add-prerecord-lesson" ||
//             location.pathname === "/live-session" ||
//             location.pathname === "/upcoming-session"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <IoMdBook
//             className="me-2"
//             color={
//               location.pathname === "/courses" ? "#136ABE" : "rgba(0,0,0,0.7)"
//             }
//             size={20}
//           />
//           <span>Courses</span>
//         </Nav.Link>
//         <Nav.Link
//           href="/vendors"
//           className={`mb-3 ${
//             location.pathname.startsWith("/vendors") ||
//             location.pathname === "/add-vendor"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <TfiMenuAlt
//             className="me-2"
//             color={
//               location.pathname === "/vendors" ? "#136ABE" : "rgba(0,0,0,0.7)"
//             }
//             size={20}
//           />
//           <span>Vendors</span>
//         </Nav.Link>
//         <Nav.Link
//           href="/colleges"
//           className={`mb-3 ${
//             location.pathname.startsWith("/colleges") ||
//             location.pathname === "/college-list" ||
//             location.pathname === "/add-college"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <BsBuildings
//             className="me-2"
//             color={
//               location.pathname === "/colleges" ? "#136ABE" : "rgba(0,0,0,0.7)"
//             }
//             size={20}
//           />
//           <span>Colleges</span>
//         </Nav.Link>
//         <Nav.Link
//           href="/teachers"
//           className={`mb-3 ${
//             location.pathname.startsWith("/teachers") ||
//             location.pathname === "/teacher-list" ||
//             location.pathname === "/add-teacher"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <FaGlasses
//             className="me-2"
//             color={
//               location.pathname === "/teachers" ? "#136ABE" : "rgba(0,0,0,0.7)"
//             }
//             size={20}
//           />
//           <span>Teachers</span>
//         </Nav.Link>
//         <Nav.Link
//           href="/students"
//           className={`mb-3 ${
//             location.pathname.startsWith("/students") ||
//             location.pathname === "/student-list" ||
//             location.pathname === "/add-student"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <FaRegUserCircle
//             className="me-2"
//             color={
//               location.pathname === "/students" ? "#136ABE" : "rgba(0,0,0,0.7)"
//             }
//             size={20}
//           />
//           <span>Students</span>
//         </Nav.Link>
//         <Nav.Link
//           href="/analytics"
//           className={`mb-3 ${
//             location.pathname === "/analytics"
//               ? "text-dark textCourse active"
//               : "text-primary textOverview"
//           }`}
//         >
//           <RiPieChartLine
//             className="me-2"
//             color={
//               location.pathname === "/analytics" ? "#136ABE" : "rgba(0,0,0,0.7)"
//             }
//             size={20}
//           />
//           <span>Analytics</span>
//         </Nav.Link>
//       </Nav>
//     </>
//   );

//   return (
//     <>
//       {/* Desktop Sidebar */}
//       <div className="d-none d-lg-block sidebar sidebar-bg sideMenu">
//         {sidebarContent}
//       </div>

//       {/* Mobile Sidebar */}
//       <Offcanvas
//         show={show}
//         onHide={onClose}
//         responsive="lg"
//         className="sidebar-mobile"
//       >
//         <Offcanvas.Header closeButton className="bgNav">
//           <Offcanvas.Title>
//             {" "}
//             <Navbar.Brand href="#home">
//               <img
//                 src="/images/Group 1.png"
//                 height="40"
//                 className="d-inline-block align-top"
//                 alt="HyTech Didactic Logo"
//               />
//             </Navbar.Brand>
//           </Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>{sidebarContent}</Offcanvas.Body>
//       </Offcanvas>
//     </>
//   );
// };

// export default Sidebar;

import React from "react";
import {
  Nav,
  Form,
  FormControl,
  Badge,
  Offcanvas,
  Navbar,
} from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { TiThLargeOutline } from "react-icons/ti";
import { IoMdBook, IoIosNotificationsOutline } from "react-icons/io";
import { TfiMenuAlt } from "react-icons/tfi";
import { BsBuildings } from "react-icons/bs";
import { FaGlasses, FaRegUserCircle } from "react-icons/fa";
import { RiPieChartLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { GiAccordion } from "react-icons/gi";
import { VscPreview } from "react-icons/vsc";

const Sidebar = ({ show, onClose }) => {
  const location = useLocation();

  // Custom NavLink component that works with react-router
  const CustomNavLink = ({ to, children, className }) => {
    const isActive = location.pathname === to;
    // const isActive =
    //   location.pathname === to || location.pathname.startsWith(to);

    return (
      <Nav.Item className="mb-3">
        <Link
          to={to}
          className={`nav-link ${className} ${
            isActive
              ? "text-dark textCourse active"
              : "text-primary textOverview"
          }`}
        >
          {children}
        </Link>
      </Nav.Item>
    );
  };

  const sidebarContent = (
    <>
      <Nav className="flex-column">
        <CustomNavLink to="/">
          <TiThLargeOutline
            className="me-2"
            color={location.pathname === "/" ? "#136ABE" : "rgba(0,0,0,0.7)"}
            size={20}
          />
          <span>Overview</span>
        </CustomNavLink>

        <CustomNavLink
          to="/courses"
          className={` ${
            location.pathname.startsWith("/courses") ||
            location.pathname === "/add-course" ||
            location.pathname === "/add-leason" ||
            location.pathname === "/add-module" ||
            location.pathname === "/add-prerecord" ||
            location.pathname === "/add-prerecord-lesson" ||
            location.pathname === "/live-session" ||
            location.pathname === "/upcoming-session"
              ? "text-primary textOverview active"
              : "text-dark "
          } textCourse`}
        >
          <IoMdBook
            className="me-2"
            color={
              location.pathname.startsWith("/courses")
                ? "#136ABE"
                : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Courses</span>
        </CustomNavLink>

        <CustomNavLink
          to="/vendors"
          className={`${
            location.pathname.startsWith("/vendors") ||
            location.pathname === "/add-vendor"
              ? "text-primary textOverview active"
              : "text-dark"
          } textCourse`}
        >
          <TfiMenuAlt
            className="me-2"
            color={
              location.pathname.startsWith("/vendors")
                ? "#136ABE"
                : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Vendors</span>
        </CustomNavLink>

        <CustomNavLink
          to="/colleges"
          className={`${
            location.pathname.startsWith("/college-list") ||
            location.pathname === "/add-college"
              ? "text-primary textOverview active"
              : "text-dark"
          } textCourse`}
        >
          <BsBuildings
            className="me-2"
            color={
              location.pathname.startsWith("/colleges")
                ? "#136ABE"
                : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Colleges</span>
        </CustomNavLink>

        <CustomNavLink
          to="/teachers"
          className={` ${
            location.pathname.startsWith("/teacher-list") ||
            location.pathname === "/add-teacher"
              ? "text-primary textOverview active"
              : "text-dark"
          } textCourse`}
        >
          <FaGlasses
            className="me-2"
            color={
              location.pathname.startsWith("/teachers")
                ? "#136ABE"
                : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Teachers</span>
        </CustomNavLink>

        <CustomNavLink
          to="/students"
          className={` ${
            location.pathname.startsWith("/student-list") ||
            location.pathname === "/add-student"
              ? "text-primary textOverview active"
              : "text-dark"
          } textCourse`}
        >
          <FaRegUserCircle
            className="me-2"
            color={
              location.pathname.startsWith("/students")
                ? "#136ABE"
                : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Students</span>
        </CustomNavLink>

        {/* <CustomNavLink to="/inquiry">
          <RiContactsBook2Fill
            className="me-2"
            color={
              location.pathname === "/inquiry" ? "#136ABE" : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Inquiry</span>
        </CustomNavLink> */}

        <CustomNavLink to="/analytics">
          <RiPieChartLine
            className="me-2"
            color={
              location.pathname === "/analytics" ? "#136ABE" : "rgba(0,0,0,0.7)"
            }
            size={20}
          />
          <span>Analytics</span>
        </CustomNavLink>
      </Nav>
    </>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="d-none d-lg-block sidebar sidebar-bg sideMenu">
        {sidebarContent}
      </div>

      {/* Mobile Sidebar */}
      <Offcanvas
        show={show}
        onHide={onClose}
        responsive="lg"
        className="sidebar-mobile"
      >
        <Offcanvas.Header closeButton className="bgNav">
          <Offcanvas.Title>
            <Link to="/">
              <img
                src="/images/Group 1.png"
                height="40"
                className="d-inline-block align-top"
                alt="HyTech Didactic Logo"
              />
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{sidebarContent}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
